import { createContext, useContext } from "react";
import { DOLMIT, type DensityKey, type DolmitTheme } from "./tokens";

export interface ThemeCtxValue {
  C: DolmitTheme;
  dark: boolean;
  density: DensityKey;
}

export const ThemeCtx = createContext<ThemeCtxValue>({
  C: DOLMIT,
  dark: false,
  density: "compact",
});

export const useC = () => useContext(ThemeCtx);
